import { useQuery } from '@tanstack/react-query'
import { getThroughput } from '../services/throughputApi'
import { FREQUENT } from '../utils/polling'

/**
 * The hourly ETL throughput series (`GET api/observatory/throughput`).
 *
 * On FREQUENT: the last bucket is the hour in progress, and its counts move as
 * entity runs finish. Nothing faster — a run finishing is the only thing that
 * changes the series.
 *
 * `hours` is in the key by value and the function is called through a closure,
 * so the key and the argument move together; a new window never serves the
 * previous one's cached series.
 *
 * CACHE-KEY HAZARD, until the fixture layer is deleted: the old `useThroughput`
 * in hooks/useOverview.ts uses this SAME key, `['observatory', 'throughput',
 * hours]`, with an incompatible payload. Mounting both would have each query
 * overwrite the other's cache entry. Do not mount this hook while anything still
 * imports that one.
 */
export function useThroughput(hours: number) {
  return useQuery({
    queryKey: ['observatory', 'throughput', hours],
    queryFn: () => getThroughput(hours),
    refetchInterval: FREQUENT,
  })
}
